export function getPreviewDocument() {
    return document;
}

export function getPreviewScrollDom() {
    return jm('#g_web')[0];
}
